export const SET_PAGES = 'SET_PAGES';
export const SET_FORMS = 'SET_FORMS';
export const SET_ALLPAGES = 'SET_ALLPAGES';
